<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <SectionLayout :settings="fields.settings" :container-page="fields.containerPage" />

        <div class="mb-5">
          <label class="label-input">Company Info</label>
          <div class="group-item">
            <div class="mb-3">
              <label>Logo</label>
              <UploadImage
                :image="{ imageSrc: fields.logo }"
                :height="`80`"
                :typeUpload="'image'"
                @callback="obj => (fields.logo = obj.imageSrc)"
                @callbackDelete="fields.logo = ''"
              />
            </div>
            <div class="mb-3">
              <label>Address</label>
              <v-textarea v-model="fields.addressText" rows="2" hide-details />
            </div>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Contact Links (max {{ MAX_EMAIL_ITEMS }})</label>
            <v-btn
              small
              color="primary"
              :disabled="fields.emailItems.length >= MAX_EMAIL_ITEMS"
              @click="handleAddEmailItem"
            >
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.emailItems" :key="`email-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn
                      icon
                      :disabled="fields.emailItems.length <= MIN_EMAIL_ITEMS"
                      @click.stop="handleRemoveEmailItem(index)"
                    >
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label>Text</label>
                    <v-text-field v-model="item.text" hide-details />
                  </div>
                  <label>Link</label>
                  <v-text-field v-model="item.link" placeholder="mailto:support@calyrafit.com" hide-details />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Social Links (max {{ MAX_SOCIAL_ITEMS }})</label>
            <v-btn
              small
              color="primary"
              :disabled="fields.socialItems.length >= MAX_SOCIAL_ITEMS"
              @click="handleAddSocialItem"
            >
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.socialItems" :key="`social-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn
                      icon
                      :disabled="fields.socialItems.length <= MIN_SOCIAL_ITEMS"
                      @click.stop="handleRemoveSocialItem(index)"
                    >
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label>Icon</label>
                    <UploadImage
                      :image="{ imageSrc: item.icon }"
                      :height="`80`"
                      :typeUpload="'image'"
                      @callback="obj => (item.icon = obj.imageSrc)"
                      @callbackDelete="item.icon = ''"
                    />
                  </div>
                  <label>Link</label>
                  <v-text-field v-model="item.link" hide-details />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Order Column (max {{ MAX_ORDER_ITEMS }})</label>
            <v-btn
              small
              color="primary"
              :disabled="fields.orderItems.length >= MAX_ORDER_ITEMS"
              @click="handleAddOrderItem"
            >
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <div class="mb-3">
              <label>Column Title</label>
              <v-text-field v-model="fields.orderTitle" hide-details />
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.orderItems" :key="`order-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn
                      icon
                      :disabled="fields.orderItems.length <= MIN_ORDER_ITEMS"
                      @click.stop="handleRemoveOrderItem(index)"
                    >
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label>Text</label>
                    <v-text-field v-model="item.text" hide-details />
                  </div>
                  <label>Link</label>
                  <v-text-field v-model="item.link" hide-details />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Resources Column (max {{ MAX_RESOURCES_ITEMS }})</label>
            <v-btn
              small
              color="primary"
              :disabled="fields.resourcesItems.length >= MAX_RESOURCES_ITEMS"
              @click="handleAddResourcesItem"
            >
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <div class="mb-3">
              <label>Column Title</label>
              <v-text-field v-model="fields.resourcesTitle" hide-details />
            </div>
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.resourcesItems" :key="`resources-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn
                      icon
                      :disabled="fields.resourcesItems.length <= MIN_RESOURCES_ITEMS"
                      @click.stop="handleRemoveResourcesItem(index)"
                    >
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label>Text</label>
                    <v-text-field v-model="item.text" hide-details />
                  </div>
                  <label>Link</label>
                  <v-text-field v-model="item.link" hide-details />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Subscribe Column</label>
          <div class="group-item">
            <div class="mb-3">
              <label>Column Title</label>
              <v-text-field v-model="fields.subscribeTitle" hide-details />
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <label>Input Placeholder</label>
                <v-text-field v-model="fields.inputPlaceholder" hide-details />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.inputColor" label="Input Color" default-color="#AD4870" />
              </v-col>
            </v-row>
            <div class="mb-3 mt-3">
              <label>Submit Icon</label>
              <UploadImage
                :image="{ imageSrc: fields.submitIcon }"
                :height="`60`"
                :typeUpload="'image'"
                @callback="obj => (fields.submitIcon = obj.imageSrc)"
                @callbackDelete="fields.submitIcon = ''"
              />
            </div>
            <div>
              <label>Description</label>
              <v-textarea v-model="fields.descriptionSubscribe" rows="2" hide-details />
            </div>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Payment Icon</label>
          <div class="group-item">
            <UploadImage
              :image="{ imageSrc: fields.paymentIcon }"
              :height="`100`"
              :typeUpload="'image'"
              @callback="obj => (fields.paymentIcon = obj.imageSrc)"
              @callbackDelete="fields.paymentIcon = ''"
            />
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Bottom Footer</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.bottomBgColor" label="Background" default-color="#AD4870" />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.bottomTextColor" label="Text Color" default-color="#FFFFFF" />
              </v-col>
            </v-row>
            <div class="mt-3">
              <label>Copyright Text</label>
              <v-text-field v-model="fields.copyrightText" hide-details />
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import SectionLayout from '../common/ui-modules/section-layout/editor.vue';
import ColorPicker from '../common/ui-modules/inputs/color-picker.vue';

const MAX_EMAIL_ITEMS = 5;
const MIN_EMAIL_ITEMS = 1;
const MAX_SOCIAL_ITEMS = 6;
const MIN_SOCIAL_ITEMS = 1;
const MAX_ORDER_ITEMS = 8;
const MIN_ORDER_ITEMS = 1;
const MAX_RESOURCES_ITEMS = 8;
const MIN_RESOURCES_ITEMS = 1;

const buildEmailItemDefault = () => ({ text: '', link: '' });
const buildSocialItemDefault = () => ({ link: '', icon: '' });
const buildOrderItemDefault = () => ({ text: '', link: '' });
const buildResourcesItemDefault = () => ({ text: '', link: '' });

const getDefaultFields = () => ({
  title: 'Calyrafit Footer Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: false,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  logo: '',
  addressText: 'Address: 524 Federal Avenue East Seattle, WA 98102 US',
  emailItems: [{ text: '📩 support@calyrafit.com', link: 'mailto:support@calyrafit.com' }],
  socialItems: [
    { link: '', icon: '' },
    { link: '', icon: '' },
  ],
  orderTitle: 'Order',
  orderItems: [
    { text: '24/7 Live Chat Support', link: '' },
    { text: 'Track My Order', link: '' },
    { text: 'Contact Us', link: '' },
    { text: 'Order & Shipping', link: '' },
    { text: 'Returns & Exchanges', link: '' },
  ],
  resourcesTitle: 'Resources',
  resourcesItems: [
    { text: 'About Us', link: '' },
    { text: 'FAQs', link: '' },
    { text: 'Terms Of Services', link: '' },
    { text: 'Privacy Policy', link: '' },
  ],
  subscribeTitle: 'Stay In The Know',
  inputPlaceholder: 'Enter Your Email...',
  inputColor: '#AD4870',
  submitIcon: '',
  descriptionSubscribe: 'Sign up to receive special offers, free gifts and once-in-a-lifetime deals.',
  bottomBgColor: '#AD4870',
  bottomTextColor: '#FFFFFF',
  copyrightText: '© 2026, CALYRAFIT™ All Rights Reserved.',
  paymentIcon: '',
});

export default {
  name: 'CalyrafitFooterSectionEditor',
  components: { UploadImage, SectionLayout, ColorPicker },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      MAX_EMAIL_ITEMS,
      MIN_EMAIL_ITEMS,
      MAX_SOCIAL_ITEMS,
      MIN_SOCIAL_ITEMS,
      MAX_ORDER_ITEMS,
      MIN_ORDER_ITEMS,
      MAX_RESOURCES_ITEMS,
      MIN_RESOURCES_ITEMS,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const extract = cloneDeep(this.sectionEditor.sectionExtract || {});

    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
      emailItems:
        Array.isArray(extract.emailItems) && extract.emailItems.length
          ? extract.emailItems.slice(0, MAX_EMAIL_ITEMS)
          : def.emailItems,
      socialItems:
        Array.isArray(extract.socialItems) && extract.socialItems.length
          ? extract.socialItems.slice(0, MAX_SOCIAL_ITEMS)
          : def.socialItems,
      orderItems:
        Array.isArray(extract.orderItems) && extract.orderItems.length
          ? extract.orderItems.slice(0, MAX_ORDER_ITEMS)
          : def.orderItems,
      resourcesItems:
        Array.isArray(extract.resourcesItems) && extract.resourcesItems.length
          ? extract.resourcesItems.slice(0, MAX_RESOURCES_ITEMS)
          : def.resourcesItems,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        emailItems: (this.fields.emailItems || []).slice(0, MAX_EMAIL_ITEMS),
        socialItems: (this.fields.socialItems || []).slice(0, MAX_SOCIAL_ITEMS),
        orderItems: (this.fields.orderItems || []).slice(0, MAX_ORDER_ITEMS),
        resourcesItems: (this.fields.resourcesItems || []).slice(0, MAX_RESOURCES_ITEMS),
      };
      const updateHtml = updateHtmlFromData.sectionCalyrafitFooter(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddEmailItem() {
      if (this.fields.emailItems.length >= MAX_EMAIL_ITEMS) return;
      this.fields.emailItems.push(cloneDeep(buildEmailItemDefault()));
    },
    handleRemoveEmailItem(index) {
      if (this.fields.emailItems.length <= MIN_EMAIL_ITEMS) return;
      this.fields.emailItems.splice(index, 1);
    },
    handleAddSocialItem() {
      if (this.fields.socialItems.length >= MAX_SOCIAL_ITEMS) return;
      this.fields.socialItems.push(cloneDeep(buildSocialItemDefault()));
    },
    handleRemoveSocialItem(index) {
      if (this.fields.socialItems.length <= MIN_SOCIAL_ITEMS) return;
      this.fields.socialItems.splice(index, 1);
    },
    handleAddOrderItem() {
      if (this.fields.orderItems.length >= MAX_ORDER_ITEMS) return;
      this.fields.orderItems.push(cloneDeep(buildOrderItemDefault()));
    },
    handleRemoveOrderItem(index) {
      if (this.fields.orderItems.length <= MIN_ORDER_ITEMS) return;
      this.fields.orderItems.splice(index, 1);
    },
    handleAddResourcesItem() {
      if (this.fields.resourcesItems.length >= MAX_RESOURCES_ITEMS) return;
      this.fields.resourcesItems.push(cloneDeep(buildResourcesItemDefault()));
    },
    handleRemoveResourcesItem(index) {
      if (this.fields.resourcesItems.length <= MIN_RESOURCES_ITEMS) return;
      this.fields.resourcesItems.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
